export const msgList: Array<{
  CD: string;
  TEXT: string;
  TYP: string;
}> = [
  {
    // コード
    CD: '0000001',
    // メッセージ文
    TEXT:
      'メッセージのサンプルです。メッセージ実装時にこちらを削除してから記載してください。',
    // メッセージ種別 INFO/WARNING/ERROR
    TYP: 'I'
  },
  {
    // コード
    CD: '0000002',
    // メッセージ文
    TEXT:
      '{{ target }}のサンプルです。メッセージ実装時にこちらを削除してから記載してください。',
    // メッセージ種別 INFO/WARNING/ERROR
    TYP: 'I'
  }
];
